import { render } from "./BannerImage.vue?vue&type=template&id=44ef3479"
import script from "./BannerImage.vue?vue&type=script&lang=js"
export * from "./BannerImage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__